<template>
    <div class="form__row row s-2-bmargin">
        <slot name="inputs" :callback="inputOnChange"></slot>
        <slot name="outputs" :selected="selected"></slot>
    </div>
</template>

<script>
export default {
    name: 'TransferGroup',

    data() {
        return {
            selected: null
        }
    },

    methods: {
        inputOnChange (geoCode) {
            this.selected = geoCode
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/transfer-group.vue